<template>
    <v-tab-item :value="COUSTOMER.value">
         <section class="sub-section">
            <v-container>
                <table class="board-list">
                    <thead class="d-none d-lg-table-header">
                        <tr>
                            <th style="width:10%;" class="board-list__txt">NO.</th>
                            <th style="width:52.5%;" class="board-list__tit">Subject</th>
                            <th style="width:12.5%;" class="board-list__txt">Writer</th>
                            <th style="width:12.5%;" class="board-list__txt">Date Created</th>
                            <th style="width:12.5%;" class="board-list__txt">Hit</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="library, index in librarys" :key="library._id">
                            <td align="center" class="board-list__txt board-list__txt--first">
                                {{ index + 1 }}
                            </td>
                            <td align="center" class="board-list__tit">
                                <div class="ellip">
                                    <router-link :to="`/resoures/customer/${library._id}`">{{ library.subject }}</router-link>
                                </div>
                            </td>
                            <td align="center" class="board-list__txt">
                                {{ library.writer.name }}
                            </td>
                            <td align="center" class="board-list__txt">
                                {{ library.createdAt.toDate() }}
                            </td>
                            <td align="center" class="board-list__txt">
                                {{ library.viewCount }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="v-pagination-wrap">
                    <v-pagination v-model="page" :length="pageCount"></v-pagination>
                </div>
            </v-container>
        </section>
    </v-tab-item>
</template>

<script>
import api from "@/api"
import { RESOURES_EN_TABS } from "@/assets/variables";
const { COUSTOMER } = RESOURES_EN_TABS;

export default {
    data() {
        return {
            librarys: [],

            filter: {
                language: "en",
                code: "resource",
                category: "CUSTOMER",
            },

            page: 1,
            totalCount: 0,
            limit: 10,

            COUSTOMER,
        }
    },
    async mounted() {
        await this.init()
    },
    computed: {
        pageCount() {
            return Math.ceil(this.totalCount / this.limit)
        },
        skip() {
            return (this.page - 1) * this.limit
        },
    },
    methods: {
        async init() {
            let { boards: librarys, summary } = await api.v1.boards.gets({
                headers: { skip: this.skip, limit: this.limit },
                params: { ...this.filter }
            })
            this.totalCount = summary.totalCount
            this.librarys = librarys
        },
    },
    watch: {
        async page() {
            await this.init()
        },
    }
}
</script>
